"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconPrintAndPromo = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("b2b-components/core/components/Icon/Icon/SvgWrapper");
const IconPrintAndPromo = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20 0a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4h16Zm-6.477 4H6v16h4.098v-5.305h3.425c1.77 0 3.125-.467 4.066-1.4.94-.934 1.411-2.25 1.411-3.948 0-1.697-.47-3.013-1.411-3.946C16.649 4.467 15.293 4 13.523 4Zm-1.02 3C14.168 7 15 7.667 15 9s-.832 2-2.497 2H10V7h2.503Z"
}));
exports.IconPrintAndPromo = IconPrintAndPromo;
//# sourceMappingURL=IconPrintAndPromo.js.map